import React from 'react';
import ReportTable from '../customers/components/reportTable';
import { formatDateDDMMYYYY } from '../../../../utils/constant';
import ReportTableActions from './reportTableActions';
import SalesSummaryCompareTable from './salesSummaryCompareTable';

export default function ReportTableComponent({
	activeTab,
	fromDate,
	toDate,
	isLoader,
	reportList,
	metaData,
	selectedColumnsList,
	params,
	setParams,
	actions,
	sortDirection,
	setSortDirection,
}) {
	return (
		<div
			className="bg-white m-4 rounded-4"
			style={{ height: 'calc(100vh - 235px)', overflow: 'hidden' }}
		>
			<ReportTableActions actions={actions} />
			<div className="py-5 text-center">
				<h2>{activeTab}</h2>
				<span
					className="fs-5 fw-light"
					style={{ color: '#555B67' }}
				>
					from {fromDate ? formatDateDDMMYYYY(fromDate) : ''}
					to {toDate ? formatDateDDMMYYYY(toDate) : ''}
				</span>
			</div>
			{isLoader ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '50vh' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : (
				<div>
					{reportList.length > 0 ? (
						params.compare_count && params.compare_type && activeTab === 'Sale By Sales Summary' ?
							<SalesSummaryCompareTable
								metaData={metaData}
								data={reportList}
								selectedColumnsList={selectedColumnsList}
								type={params.compare_count && params.compare_type ? 'compareTable' : 'table'}
								setParams={setParams}
								params={params}
							/>
							:
							<ReportTable
								metaData={metaData}
								data={reportList}
								selectedColumnsList={selectedColumnsList}
								type={params.compare_count && params.compare_type ? 'compareTable' : 'table'}
								setParams={setParams}
								params={params}
								setSortDirection={setSortDirection}
								sortDirection={sortDirection}
								activeTab={activeTab}
							/>
					) : (
						<div className="fs-2 fw-bold text-dark text-center py-4">No Data Found</div>
					)}
				</div>
			)}
		</div>
	);
}
